import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_MODAL_REMOVE_ATTACHMENT_SHOW =
  "CE_MODAL_REMOVE_ATTACHMENT_SHOW";
export const ceModalRemoveAttachmentShow = (clientAttachmentID) => ({
  type: CE_MODAL_REMOVE_ATTACHMENT_SHOW,
  client_attachment_id: clientAttachmentID,
});

export const CE_MODAL_REMOVE_ATTACHMENT_CONFIRM =
  "CE_MODAL_REMOVE_ATTACHMENT_CONFIRM";
export const ceModalRemoveAttachmentConfirm = () => {
  return {
    type: CE_MODAL_REMOVE_ATTACHMENT_CONFIRM,
  };
};

export const ceModalRemoveAttachmentCancel = () => ({
  type: CE_MODAL_CLOSE,
});
